import { httpClient } from "../http/httpClient";

export type CreateLinkRequest = {
  name: string;
  label?: string;
  tables: string[];
};

export type CreateLinkResponse = {
  _id: string;
  name: string;
  seller: string;
  entry_count: number;
  createdAt: string;
  updatedAt: string;
  tables?: string[];
};

export const createLink = async (params: CreateLinkRequest) => {
  const { data } = await httpClient
    .post<CreateLinkResponse>("/self-hire", params)
    .catch((error) => {
      throw error?.response?.data || error;
    });
  return data;
};
